import React, { useState } from 'react';
import axios from '../api/axios';
import { toast } from './Toast';
import './ProcessPayrollModal.css';

function ProcessPayrollModal({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    payPeriodStart: '',
    payPeriodEnd: '',
    defaultDeductions: 0
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.payPeriodEnd && formData.payPeriodStart && formData.payPeriodEnd < formData.payPeriodStart) {
      toast.error('Pay period end date must be after start date');
      return;
    }

    setLoading(true);

    try {
      await axios.post('/payroll/process', {
        payPeriodStart: formData.payPeriodStart,
        payPeriodEnd: formData.payPeriodEnd,
        defaultDeductions: parseFloat(formData.defaultDeductions) || 0
      });
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.error?.message || err.response?.data?.message || 'Failed to process payroll');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Process Payroll</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Pay Period Start *</label>
            <input
              type="date"
              name="payPeriodStart"
              value={formData.payPeriodStart}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Pay Period End *</label>
            <input
              type="date"
              name="payPeriodEnd"
              value={formData.payPeriodEnd}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Default Deductions (₹)</label>
            <input
              type="number"
              name="defaultDeductions"
              value={formData.defaultDeductions}
              onChange={handleChange}
              min="0"
              step="0.01"
            />
            <small>This amount will be deducted from all employees' salaries</small>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Processing...' : 'Process Payroll'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProcessPayrollModal;
